import React, { useEffect } from "react";
import { Button, Typography } from "../components/common";

/**
 * Admin-console Trial-expired conversion-prompt page (Phase 3d).
 *
 * Same contract as the learner-app variant: triggered when the global
 * `installTrialExpiredHandler` interceptor sees a 403 with body
 * error_code=trial_expired from any protected backend surface.
 */
const SUPPORT_EMAIL = "hello@pedagogue.io";
const SUBSCRIPTION_URL = new URL('/subscription',process.env.REACT_APP_APP_HOME_URL || 'https://app.pedagogue.io').toString();

const TrialExpired: React.FC = () => {
  useEffect(()=>{
    const existing=document.querySelector<HTMLMetaElement>('meta[name="robots"]'),previous=existing?.content;
    const meta=existing||document.createElement('meta');meta.name='robots';meta.content='noindex, nofollow';
    if(!existing)document.head.appendChild(meta);
    return ()=>{if(existing)meta.content=previous||'';else meta.remove();};
  },[]);
  return (
    <main
      data-testid="trial-expired-page"
      className="flex min-h-screen items-center justify-center bg-slate-50 px-6"
    >
      <div className="w-full max-w-xl rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <Typography variant="h1" weight="bold" className="mb-3 text-slate-900">
          Your Pedagogue trial has ended
        </Typography>
        <Typography variant="p" className="mb-5 text-slate-700">
          Thanks for exploring Pedagogue. The trial for your
          organisation has finished, so admin access is now paused.
        </Typography>
        <Typography variant="p" className="mb-6 text-slate-700">
          To continue, review your school’s subscription and the package that fits your staff, or email us to discuss your options.
        </Typography>
        <div className="flex flex-col gap-4 sm:flex-row">
          <Button
            onClick={() =>
              (window.location.href = SUBSCRIPTION_URL)
            }
            variant="filled"
            size="large"
          >
            View your school’s subscription
          </Button>
          <Button
            onClick={() =>
              (window.location.href = `mailto:${SUPPORT_EMAIL}?subject=Trial%20question`)
            }
            variant="outline"
            size="large"
          >
            Email {SUPPORT_EMAIL}
          </Button>
        </div>
      </div>
    </main>
  );
};

export default TrialExpired;
